import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const customIcon = new L.DivIcon({
    className: 'custom-marker',
    html: '<div class="circle-marker"></div>',
    iconSize: [10, 10],
    iconAnchor: [5, 5]
});

export const Map = ({ chartData, zoom = 11 }) => {
    const center =
        chartData && chartData.length > 0
            ? [chartData[0].latitude, chartData[0].longitude]
            : [-23.5489, -46.6388];
    return (
        <MapContainer
            center={center}
            zoom={zoom}
            className="leaflet-container-dashboards w-100%"
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {chartData.map((city, index) => (
                <Marker
                    key={index}
                    position={[city.latitude, city.longitude]}
                    icon={customIcon}
                >
                    <Popup>
                        {city.location && city.address
                            ? `${city.location} - ${city.address}`
                            : 'Total'}
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
};
